function o({ r: t, g: r, b: e }) {
  return "#" + (t << 16 | r << 8 | e).toString(16).padStart(6, "0");
}
export {
  o as rgbToHex
};
//# sourceMappingURL=index4.js.map
